export default __webpack_public_path__ + "static/media/Sepp-auf-Wiese.556fe3ae.webp";